import { useState, useRef, useCallback, useEffect } from 'react'

const POPUP_HIDE_DELAY = 800

const useDotsPopup = () => {
  const [popupData, setPopupData] = useState(null)
  const popupActiveRef = useRef(false)
  const timerRef = useRef(null)

  const hidePopup = useCallback(() => {
    popupActiveRef.current = false
    setPopupData(null)
  }, [])

  const handleDotMouseOver = useCallback(({ group, cx, cy, comments }) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
      timerRef.current = null
    }
    setPopupData({
      group,
      coords: [parseFloat(cx), parseFloat(cy)],
      comments: comments || []
    })
  }, [])

  const handleDotMouseOut = useCallback(() => {
    timerRef.current = setTimeout(() => {
      if (popupActiveRef.current) return
      timerRef.current = null

      hidePopup()
    }, POPUP_HIDE_DELAY)
  }, [hidePopup])

  const handleDotsPopupMouseEnter = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
      timerRef.current = null
    }

    popupActiveRef.current = true
  }, [])

  const handleDotsPopupMouseLeave = useCallback(() => {
    popupActiveRef.current = false

    timerRef.current = setTimeout(() => {
      timerRef.current = null
      hidePopup()
    }, POPUP_HIDE_DELAY)
  }, [hidePopup])

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [])

  return {
    dotsPopupData: popupData,
    handleDotMouseOver,
    handleDotMouseOut,
    handleDotsPopupMouseEnter,
    handleDotsPopupMouseLeave
  }
}

export default useDotsPopup
